import { BadgeJapaneseYen, Building2, Clock3, ShieldCheck, UsersRound } from "lucide-react";
import type { AppConfig } from "../../shared/domain";
import { yen } from "../../shared/calculations";
import { Section } from "../components/ui";

export function SettingsPage({ config }: { config: AppConfig }) {
  return (
    <div className="page-stack">
      <header className="page-heading">
        <div>
          <span className="eyebrow"><ShieldCheck size={15} /> 参照専用</span>
          <h1>店舗設定</h1>
          <p>変更はGoogleスプレッドシートの「設定」タブでオーナーが行います。</p>
        </div>
      </header>
      <div className="two-column-grid">
        <Section title="店舗" icon={<Building2 size={19} />}>
          <dl className="settings-list">
            <div><dt>店舗名</dt><dd>{config.storeName}</dd></div>
            <div><dt>store_id</dt><dd><code>{config.storeId}</code></dd></div>
            <div><dt>タイムゾーン</dt><dd>{config.timezone}</dd></div>
            <div><dt>既定の開始レジ金</dt><dd>{yen(config.defaultOpeningRegisterCash)}</dd></div>
          </dl>
        </Section>
        <Section title="賃金・上限" icon={<BadgeJapaneseYen size={19} />}>
          <dl className="settings-list">
            <div><dt>深夜割増</dt><dd>{config.lateNightPremiumRate * 100}%</dd></div>
            <div><dt>円未満処理</dt><dd>{config.wageRoundingMode}</dd></div>
            <div><dt>1明細上限</dt><dd>{yen(config.maxLineAmount)}</dd></div>
            <div><dt>1日売上上限</dt><dd>{yen(config.maxDailyAmount)}</dd></div>
            <div><dt>レジ差額許容</dt><dd>{yen(config.registerDifferenceTolerance)}</dd></div>
          </dl>
        </Section>
      </div>
      <Section title="従業員と時給" description="保存時に時給スナップショットを固定します" icon={<UsersRound size={19} />}>
        <div className="staff-settings-grid">
          {config.staff.map((staff) => (
            <article key={staff.staffId} className="staff-settings-card">
              <span className={`staff-status ${staff.active ? "is-active" : ""}`}>{staff.active ? "在籍" : "無効"}</span>
              <strong>{staff.staffName}</strong>
              <small>{staff.staffId}</small>
              <div><Clock3 size={15} /> 時給 {yen(staff.hourlyRate)}</div>
            </article>
          ))}
        </div>
      </Section>
    </div>
  );
}
